<template>
  <VDialogV3
    id="shipment-to-buyer-card"
    position="bottom"

    :entity="localShipmentToBuyer"
    :title="localShipmentToBuyer?.toString()"
    :submit-disabled="true"
  >
    <header class="document-header">
      <dl>
        <dt>Продавец</dt>
        <dd>{{ localShipmentToBuyer.sellerString}}</dd>
      </dl>
      <dl>
        <dt>Покупатель</dt>
        <dd>{{ localShipmentToBuyer.buyerString }}</dd>
      </dl>
    </header>

    <header class="document-header">
      <dl>
        <dt>Дата отгрузки</dt>  <dd>{{ localShipmentToBuyer.shipmentDate?.format() || 'Не задано' }}</dd>

      </dl>

      <aside class="totals">
        <section>
          <header>В валюте сделки</header>
          <dl>
            <dt class="total">Итого</dt>
            <dd class="total">
              {{ localShipmentToBuyer.sumFull.format(localShipmentToBuyer.orderCurrency) || '---' }}
            </dd>
            <dt>НДС в т.ч.</dt>
            <dd>
              {{ localShipmentToBuyer.vatSum.format(localShipmentToBuyer.orderCurrency) || '---' }}            </dd>
          </dl>
        </section>

        <section>
          <header>В валюте учёта, курс {{ localShipmentToBuyer.accountingCurrencyRate }}</header>
          <dl>
            <dt class="total">Итого</dt>
            <dd class="total">
              {{ localShipmentToBuyer.accountingSumFull?.format(localShipmentToBuyer.accountingCurrency) || '---' }}
            </dd>
            <dt>НДС в т.ч.</dt>
            <dd>
              {{ localShipmentToBuyer.accountingVatSum.format(localShipmentToBuyer.accountingCurrency) || '---' }}
            </dd>
          </dl>
        </section>
      </aside>
    </header>

    <VDataGridV2
      :data="localShipmentToBuyer?.positions"
      layout="fill"
    >
      <VDataGridColumnV2
        id="id"
        content-align="center"
        width="90px"
        label="№"
      >
        <template #default="{ row }">
          {{ row.orderPosition !== null ? $core.utils.string.formatWithDelimiter(row.orderPosition.id) : '' }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="name"
        label="Товар"
        content-align="left"
        width="400px"
        content-class="ellipsis"
      >
        <template #default="{ row }">
          <template v-if="row.product?.isService === true">
            {{ row.product.name }}
          </template>
          <template v-else>
            {{ row.orderPosition.name }}
          </template>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="qty"
        content-align="right"
        content-class="form"
        width="140px"
        label="Кол-во"
      >
        <template #default="{ row }">
          <VInputNumberRusV2
            v-model="row.qty"
            :type="Qty"
            disabled
            :unit="row.orderPosition.unit"
          >
          </VInputNumberRusV2>
        </template>
      </VDataGridColumnV2>

    <VDataGridColumnV2
        id="price-full"
        content-align="right"
        content-class="form"
        width="140px"
      >
        <template #label>
          <div>Цена</div>
          <div class="description">В валюте</div>
        </template>
        <template #default="{ row }">
          <VInputNumberRusV2
            :type="Price"
            :unit="$core.utils.money.getSymbolByCurrency(row.accountingCurrencyCode)"
            :model-value="row.accountingPrice ?? row.accountingPriceCalculated"
            disabled
          />

          <span class="description">
            {{ row.price.format(row.orderCurrency) || '---' }}
          </span>
        </template>
      </VDataGridColumnV2>

     <VDataGridColumnV2
        id="accounting-sum-full"
        content-align="right"
        content-class="form"
        width="170px"
      >
        <template #label>
          <div>Сумма полная</div>
          <div class="description">В валюте</div>
        </template>
        <template #default="{ row }">
          <VInputNumberRusV2
            ref="sumAccounting"
            :type="Sum"
            disabled
            :unit="$core.utils.money.getSymbolByCurrency(row.accountingCurrencyCode)"
            :model-value="row.accountingSumFull ?? row.accountingSumFullCalculated"
          />

          <span class="description">
            {{ row.sumFull.format(row.orderCurrency) || '---' }}
          </span>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="vat-rate"
        label="НДС"
        width="60px"
        content-align="right"
      >
        <template #default="{ row }">
          {{ row.vatRate || '---' }}
        </template>

      </VDataGridColumnV2>

      <VDataGridColumnV2
        width="120px"
        content-align="right"
        content-class="form"
      >
        <template #label>
          <div>Сумма НДС</div>
          <div class="description">В валюте</div>
        </template>
        <template #default="{ row }">
          <VInputNumberRusV2
            ref="accounting-vat-sum"
            :type="Sum"
            disabled
            :unit="$core.utils.money.getSymbolByCurrency(row.accountingCurrencyCode)"
            :model-value="row.accountingVatSum"
          />
          <span class="description">
            {{ row.vatSum.format(row.orderCurrency) || '---' }}
          </span>
        </template>
      </VDataGridColumnV2>
    </VDataGridV2>
  </VDialogV3>
</template>

<style lang="scss" src="./ShipmentToBuyerCard.scss"></style>
<script lang="ts">

import ShipmentToBuyer from '@/domains/ShipmentsToBuyer/ShipmentToBuyer';
import ShipmentToBuyerPosition  from '@/domains/ShipmentsToBuyer/ShipmentToBuyerPosition';
import ShipmentsToBuyerService from   '@/domains/ShipmentsToBuyer/ShipmentsToBuyerService'
import ShipmentsService from '@/domains/Shipments/ShipmentsService';
import OrdersService from '@/domains/Orders/OrdersService';
import Qty   from '@/core/types/Qty';
import Price from '@/core/types/Price';
import Sum   from '@/core/types/Sum';

export default {
  name: 'ShipmentToBuyerCard',

  props: {
    /** ID реализации  */
    id: {
      type: Number,
      default: null,
    },
  },


  setup() {
    return {
      ShipmentsService,
      OrdersService,
      ShipmentToBuyerPosition,
      Qty,
      Price,
      Sum,
    }
  },


  data() {
    return {
      localShipmentToBuyer: null as ShipmentToBuyer | null,

      isLoading: false,
    };
  },

  computed: {
    hasPositions() {
      return Array.isArray(this.localShipmentToBuyer?.positions)
        ? this.localShipmentToBuyer?.positions.length > 0
        : false;
    },
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init() {
      if (this.id) {
          this.localShipmentToBuyer = await ShipmentsToBuyerService.get(this.id);
      }
    },
  },
};
</script>
